<template>
  <div class="level_warp">
    <div class="index-name">
      <span>{{ data.name }}</span>
      <el-button
        size="mini"
        type="primary"
        plain
        @click="$router.push(data.path)"
        >编辑</el-button
      >
    </div>
    <li class="lower-level-line line"></li>
    <div class="level">
      <div
        class="level_warp"
        :class="{ mantle: data.children.length > 1 }"
        v-for="item in data.children"
        :key="item.name"
      >
        <li class="higher-level-line line"></li>
        <div class="index-name">
          <span class="name">{{ item.name }}</span>
          <el-button
            size="mini"
            type="primary"
            plain
            @click="$router.push(item.path)"
            >编辑</el-button
          >
        </div>
        <li class="lower-level-line line" v-if="item.children"></li>
        <div :class="{ level: item.children.length > 1 }" v-if="item.children">
          <div
            class="level_warp"
            :class="{ mantle: item.children.length > 1 }"
            v-for="i in item.children"
            :key="i.name"
          >
            <li
              class="higher-level-line line"
              v-if="item.children.length > 1"
            ></li>
            <div class="index-name">
              <span class="name">{{ i.name }}</span>
              <el-button
                size="mini"
                type="primary"
                plain
                @click="$router.push(i.path)"
                >编辑</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {
        name: "首页",
        path: "/operate/pageManage/home",
        children: [
          {
            name: "搜索页",
            path: "/operate/pageManage/search",
            children: [
              {
                name: "个人主页（前台）",
                path: "/operate/pageManage/personal",
              },
            ],
          },
          {
            name: "信用模块介绍页",
            path: "/operate/pageManage/modular",
          },
          {
            name: "行业动态专题页",
            path: "/operate/pageManage/information",
          },
          {
            name: "企业资讯专题页",
            path: "/operate/pageManage/companyInfo",
          },
          {
            name: "个人动态专题页",
            path: "/operate/pageManage/square",
          },
          {
            name: "政策法规专题页",
            path: "/operate/pageManage/statute",
            children: [
              {
                name: "政策法规详情页",
                path: "/operate/pageManage/statuteInfo",
              },
            ],
          },
          {
            name: "产品超市专题页",
            path: "/operate/pageManage/product",
            children: [
              {
                name: "产品详情页",
                path: "/operate/pageManage/productInfo",
              },
            ],
          },
          {
            name: "招标大厅专题页",
            path: "/operate/pageManage/bidding",
            children: [
              {
                name: "招标详情页",
                path: "/operate/pageManage/biddingInfo",
              },
            ],
          },
          {
            name: "投融库专题页",
            path: "/operate/pageManage/invest",
          },
          {
            name: "职位专题页",
            path: "/operate/pageManage/position",
            children: [
              {
                name: "职位详情页",
                path: "/operate/pageManage/positionInfo",
              },
            ],
          },
          {
            name: "培训课程专题页",
            path: "/operate/pageManage/train",
            children: [
              {
                name: "培训课程搜索页",
                path: "/operate/pageManage/trainSearch",
              },
              {
                name: "专题详情页",
                path: "/operate/pageManage/trainInfo",
              },
            ],
          },
          {
            name: "诚信承诺专题页",
            path: "/operate/pageManage/promise",
          },
          {
            name: "线下活动专题页",
            path: "/operate/pageManage/activity",
          },
          {
            name: "新闻资讯专题页",
            path: "/operate/pageManage/news",
          },
        ],
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.level_warp {
  .mantle {
    &:first-child {
      position: relative;
      &::before {
        top: 0;
        content: "";
        width: 1px;
        height: 50%;
        position: absolute;
        background-color: #ffffff;
      }
    }
    &:last-child {
      position: relative;
      &::after {
        content: "";
        width: 1px;
        bottom: 0;
        position: absolute;
        height: calc(50% - 1px);
        background-color: #ffffff;
      }
    }
  }
}

.level_warp {
  display: flex;
  padding: 12px 0;
  align-items: center;

  .title {
    display: flex;
    padding: 10px;
    align-items: center;
    border: 1px solid $--color-primary;
    border-radius: $--border-radius-base;
    span {
      font-size: 0.75rem;
    }
  }

  .line {
    width: 60px;
    height: 1px;
    min-width: 30px;
    background-color: $--color-primary;
    &[class*="lower-level-line"] {
      max-width: 100px;
    }
  }

  .index-name {
    width: 170px;
    display: flex;
    padding: 4px 15px;
    align-items: center;
    border: 1px solid $--color-primary;
    span {
      font-size: 0.875rem;
    }
    .el-button {
      margin-left: auto;
    }
  }

  .level {
    position: relative;

    &::before {
      top: 0;
      left: 0;
      bottom: 0;
      content: "";
      width: 1px;
      position: absolute;
      background-color: $--color-primary;
    }
  }
  .score {
    height: 40px;
    padding: 0 24px;
    line-height: 40px;
    font-size: 0.875rem;
    border: 1px solid $--color-primary;
    border-radius: $--border-radius-base;
  }
}
</style>